import { apiUrls } from "../../config/apiUrls";
import { IApiServiceResponse } from "../../types/api";
import basicRequest from "../basicRequest";

type PostDocumentAttachmentRequest = {
    id: string;
    fileName: string;
    file: string;
}

export const documentsService = {
    dashboardDocuments: async (): Promise<IApiServiceResponse> => {
        const request = new basicRequest();
        return await request.get(apiUrls.dashboardDocuments);
    },
    getDocuments: async (): Promise<IApiServiceResponse> => {
        const request = new basicRequest();
        return await request.get(apiUrls.getDocuments);
    },
    getAttachment: async (documentId: string): Promise<IApiServiceResponse> => {
        const request = new basicRequest();
        return await request.get(apiUrls.getDocumentAttachment, {
            documentId: documentId
        });
    },
    postAttachment: async (data: PostDocumentAttachmentRequest): Promise<IApiServiceResponse> => {
        const request = new basicRequest();
        return await request.post(apiUrls.postDocumentAttachments, data);
    },
    getTemplate: async (documentId: string): Promise<IApiServiceResponse> => {
        const request = new basicRequest();
        return await request.get(apiUrls.getDocumentTemplate, {
            documentId: documentId
        });
    },
}